import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C8TransactionsEdit } from "./edit";
import { C8TransactionsNew } from "./new";
import { C8TransactionsTable } from "./table";

const client = "c8";
const table_name = "c8_transactions";

export default function C8Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C8TransactionsEdit />} />
      <Route index element={<C8TransactionsTable />} />
      <Route
        path="/new"
        element={<C8TransactionsNew client={client} table_name={table_name} />}
      />
    </Routes>
  );
}
